import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment-timezone";
import SimpleTable from "../../../../../../components/SimpleTable";
import { useIsTemplate } from "../../../hooks/useIsTemplate";
import { dateTimeFormat } from "../../../../../../utils/helpers/date";
import { cn } from "../../../../../../lib/utils";

const columnsHelper = createColumnHelper();

function Table({ data }: any) {
    const { t } = useTranslation();
    const isTemplate = useIsTemplate();

    const columns = useMemo(() => {
        let columns: any = [
            columnsHelper.accessor("employee", {
                header: t("employee"),
            }),
            columnsHelper.accessor("baseStartDate", {
                header: t("original-start-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value &&
                        dateTimeFormat(moment(value), "MMMM Do YYYY, hh:mm:ss A")
                }
            }),
            columnsHelper.accessor("startDate", {
                header: t("new-start-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value &&
                        dateTimeFormat(moment(value), "MMMM Do YYYY, hh:mm:ss A")
                }
            }),
            columnsHelper.accessor("baseEndDate", {
                header: t("original-end-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value &&
                        dateTimeFormat(moment(value), "MMMM Do YYYY, hh:mm:ss A")
                }
            }),
            columnsHelper.accessor("endDate", {
                header: t("new-end-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value &&
                        dateTimeFormat(moment(value), "MMMM Do YYYY, hh:mm:ss A")
                }
            }),
            columnsHelper.accessor("message", {
                header: t("status"),
                cell: ({ row: { original: { success, message } } }: any) => (
                    <span
                        className={cn(
                            !success ? "tw-text-rose-500" : "tw-text-green-500",
                        )}
                    >
                        {message}
                    </span>
                ),
            }),
        ];

        if (isTemplate) {
            columns = [
                columnsHelper.accessor("employee", {
                    header: t("user")
                }),
                columnsHelper.accessor("sourceDay", {
                    header: t("original-day"),
                    cell: (info: any) => {
                        const value = info.getValue();
                        return t(value);
                    }
                }),
                columnsHelper.accessor("targetDay", {
                    header: t("new-day"),
                    cell: (info: any) => {
                        const value = info.getValue();
                        return t(value);
                    }
                }),
                columnsHelper.accessor("message", {
                    header: t("status"),
                    cell: ({ row: { original: { success, message } } }: any) => (
                        <span
                            className={cn(
                                !success ? "tw-text-rose-500" : "tw-text-green-500",
                            )}
                        >
                            {message}
                        </span>
                    ),
                }),
            ]
        }
        return columns;
    }, [isTemplate, t]);

    return (
        <div className="copy-table-wrapper">
            <SimpleTable
                data={data}
                columns={columns}
                footer={false}
                enableRowSelection={false}
                loading={undefined}
                getRowProps={undefined}
            />
        </div>
    );
}

export default Table;
